import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../http/http.service';
import {
  ActiveBrandVouchersResponse,
  BrandVoucher,
  BrandVoucherDetail,
  CreateBrandVoucherRequest,
  RedeemBrandVoucherRequest,
} from '@/app/common/general-types/brand-voucher.dto';

@Injectable({ providedIn: 'root' })
export class VoucherService {
  private readonly httpService = inject(HttpService);

  create(body: CreateBrandVoucherRequest): Observable<BrandVoucher> {
    return this.httpService.runHttpCall('POST', '/brand-vouchers', 'application/json', body);
  }

  hasActive(businessAccountId: string): Observable<ActiveBrandVouchersResponse> {
    return this.httpService.runHttpCall(
      'GET',
      `/brand-vouchers/active/${businessAccountId}`,
      'application/json',
    );
  }

  redeemByName(body: RedeemBrandVoucherRequest): Observable<BrandVoucher> {
    return this.httpService.runHttpCall(
      'POST',
      '/brand-vouchers/redeem-by-name',
      'application/json',
      body,
    );
  }

  listAll(): Observable<BrandVoucher[]> {
    return this.httpService.runHttpCall('GET', '/brand-vouchers', 'application/json');
  }

  getById(id: string): Observable<BrandVoucherDetail> {
    return this.httpService.runHttpCall('GET', `/brand-vouchers/${id}`, 'application/json');
  }

  disable(id: string): Observable<BrandVoucher> {
    return this.httpService.runHttpCall('PATCH', `/brand-vouchers/${id}/disable`, 'application/json');
  }
}
